import { ObservableModelNode } from "../observable";
import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import {
  cloneValue,
  expectObject,
  readOptionalNumber,
  readString,
  splitKnown,
} from "../utils";

export class DecorationCreditsStepModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    thresholdInInches: {
      label: "Threshold in inches",
      fieldType: "number",
      allowNull: true,
    },
    extraCredits: {
      label: "Extra credits",
      fieldType: "number",
      allowNull: true,
    },
    priceExplanationKey: {
      label: "Price explanation key",
      fieldType: "text",
    },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  thresholdInInches!: number | null;
  extraCredits!: number | null;
  priceExplanationKey!: string;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("thresholdInInches", null);
    this.defineObservableValue("extraCredits", null);
    this.defineObservableValue("priceExplanationKey", "");
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "decoration credit step");
    this.thresholdInInches = readOptionalNumber(source, "thresholdInInches");
    this.extraCredits = readOptionalNumber(source, "extraCredits");
    this.priceExplanationKey = readString(source, "priceExplanationKey");
    this.extra = splitKnown(source, [
      "thresholdInInches",
      "extraCredits",
      "priceExplanationKey",
    ]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.thresholdInInches !== null
        ? { thresholdInInches: this.thresholdInInches }
        : {}),
      ...(this.extraCredits !== null
        ? { extraCredits: this.extraCredits }
        : {}),
      ...(this.priceExplanationKey
        ? { priceExplanationKey: this.priceExplanationKey }
        : {}),
    };
  }
}
